import React from 'react';
import { Trans } from '@lingui/react/macro';
import { FilterItem } from '@/types';
import { HistorySearchFilters, getHistoryLogFilterData } from '@/services/object-history-log';
import { historyLogActions } from './HistoryLogActions';
import { objectHistoryLogObjectTypes } from './HistoryLogObjectType';
import { useAsyncState } from '@/utils/hooks';
import {
    FilterDropDown,
    FilterPopOut,
    LoadingIndicator,
    SingleFilterDropDown,
} from '@ygtechnologies/bygr-frontend-component-library';
import { useLingui } from '@lingui/react';

interface HistoryLogFilterPopOutProps {
    show: boolean;
    toggle(): void;
    filter: HistorySearchFilters;
    onChange(v: HistorySearchFilters): void;
}

const HistoryLogFilterPopOut = ({ show, toggle, filter, onChange }: HistoryLogFilterPopOutProps) => {
    const { _ } = useLingui();
    const [filterData] = useAsyncState(() => getHistoryLogFilterData(filter), [], null);

    const objectTypes: FilterItem[] = objectHistoryLogObjectTypes.map((x) => ({
        id: x,
        name: _({ id: `HistoryLog.ObjectType.${x}` }),
    }));
    const actions: FilterItem[] = filter.objectType
        ? historyLogActions[filter.objectType].map(
              (x: string) =>
                  ({
                      id: x,
                      name: _({ id: `HistoryLog.Action.${x}` }),
                  }) as FilterItem
          )
        : [];
    if (!filterData) {
        return <LoadingIndicator />;
    }
    return (
        <FilterPopOut onClose={toggle} isVisible={show}>
            <SingleFilterDropDown
                onChange={(v) => onChange({ ...filter, objectType: v?.id })}
                data={objectTypes}
                value={filter.objectType || ''}
                isClearable
                label={<Trans>Object type</Trans>}
            />
            <FilterDropDown
                value={filter.operationKey || []}
                onChange={(v) => onChange({ ...filter, operationKey: v.map((x) => x.id) })}
                placeholder={<Trans>Select an object type to get options</Trans>}
                label={<Trans>Action</Trans>}
                data={actions}
            />

            <FilterDropDown
                data={filterData?.performedBy}
                label={<Trans>Performed by user</Trans>}
                value={filter.performedByUserIds || []}
                onChange={(v) => onChange({ ...filter, performedByUserIds: v.map((x) => x.id) })}
            />
        </FilterPopOut>
    );
};

export default HistoryLogFilterPopOut;
